import { useMutation } from '@tanstack/react-query'

import { postCanaryRoutingCheck } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'

export const usePostCanaryRoutingCheck = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: () => postCanaryRoutingCheck(axiosInstance),
  })
}
